import { getBrand } from 'src/environments/brand';
import { Component, OnInit, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProjectService } from 'src/app/Services/project.service';
import { UserService } from 'src/app/Services/user.service';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';

@Component({
  selector: 'ze-top-nav-component',
  templateUrl: './top-nav-component.component.html',
  styleUrls: ['./top-nav-component.component.scss']
})
export class TopNavComponentComponent implements OnInit {
  pageobject: any = {};
  brand = getBrand();
  user: string = "";
  expand1: boolean = false;
  showPageOptions: boolean = true;
  showPageOptionsDropdown: boolean = false;
  showProjectName: boolean = true;
  hidePageOptionsForIntegration: boolean = false;
  currentUrl: string = "";
  isAdmin : boolean = false;
  hasAnyIntegrationAccess$: Observable<boolean>;
  private hideDropdownTimeout: any;
  static currentPage: any = {
    name: ""
  };
  currentProject: any = {
    name: ""
  };
  currentComponent: string;

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef,
    private projectService: ProjectService,
    private elementRef: ElementRef,
    private userService: UserService,
    public featureAccessService: FeatureAccessService
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.url.split('/', 2)[1].split('?')[0];
        TopNavComponentComponent.currentPage['name'] = event.url.split('/')[1].split('?')[0];
        if (event.urlAfterRedirects.includes('settings/integration')) {
          this.hidePageOptionsForIntegration = true;
          this.showPageOptions = false;
          this.showProjectName = false;
        } else if (TopNavComponentComponent.currentPage['name'] == 'administration') {
          this.hidePageOptionsForIntegration = false;
          this.showPageOptions = false;
          this.showProjectName = false;
        } else if (TopNavComponentComponent.currentPage['name'] == 'access-required') {
          this.hidePageOptionsForIntegration = false;
          this.showPageOptions = false;
          this.showProjectName = false;
        } else if (TopNavComponentComponent.currentPage['name'] == 'video-viewer' || TopNavComponentComponent.currentPage['name'] == 'report-viewer') {
          this.hidePageOptionsForIntegration = false;
          this.showPageOptions = true;
          this.showProjectName = false;
        } else if (TopNavComponentComponent.currentPage['name'] == 'map') {
          this.hidePageOptionsForIntegration = false;
          this.showPageOptions = true;
          this.showProjectName = true;
        } else {
          this.hidePageOptionsForIntegration = false;
          this.showPageOptions = true;
          this.showProjectName = true;
        }
        if (this.showProjectName) {
          this.currentProject.name = localStorage.getItem("projectName") || "";
        }
        TopNavComponentComponent.currentPage.name = TopNavComponentComponent.currentPage.name.replace(
          TopNavComponentComponent.currentPage.name.charAt(0),
          TopNavComponentComponent.currentPage.name.charAt(0).toUpperCase()
        );
        if (TopNavComponentComponent.currentPage.name.toLowerCase() === 'ci-cd') {
          TopNavComponentComponent.currentPage.name = 'CI/CD';
        } else {
          TopNavComponentComponent.currentPage.name = TopNavComponentComponent.currentPage.name.replace(
            /-(.)/g,
            (match, nextChar) => ' ' + nextChar.toUpperCase()
          );
        }
this.pageobject = TopNavComponentComponent.currentPage;
        this.ref.markForCheck();
        this.ref.detectChanges();
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setCurrentComponent(event.urlAfterRedirects);
        this.expand1 = false;
        this.hidePageOptionsMenu();
      }
    });
  }

  ngOnInit() {
    this.projectService.projectNameValue.subscribe((projectName) => {
      this.currentProject.name = projectName || ""; // Assign the retrieved value or an empty string if it's null
      this.ref.detectChanges();
    });

    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.user = this.parseJwt(JSON.stringify(currentUser1)).sub;

    this.userService.isAdmin().subscribe({
      next: (response: any) => {
       this.isAdmin = (response && response.data != null) ? response.data : false; // fallback
      },
      error: () => {
        this.isAdmin = false; // fallback on API error
      }
    });

    // Load non-project feature access and compute integration visibility
    this.featureAccessService.loadNonProjectAccess().subscribe();

    // Restore project-level access after refresh.
    // The access map lives in memory (BehaviorSubject) so it is lost on every
    // page reload. Re-fetching here ensures feature guards work correctly
    // regardless of how the user arrived at the current page.
    const projectId = localStorage.getItem('projectId');
    if (projectId && !this.featureAccessService.isLoaded) {
      this.featureAccessService.loadProjectAccess(projectId).subscribe();
    }

    this.hasAnyIntegrationAccess$ = this.featureAccessService.nonProjectAccessMap.pipe(
      map(map => {
        if (map === null) return false; // still loading – hide until resolved
        return [
          'GITHUB_INTEGRATION',
          'JIRA_INTEGRATION',
          'AGILE_INTEGRATION',
          'SLACK_INTEGRATION'
        ].some(code => this.featureAccessService.isNonProjectVisible(code));
      })
    );
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  expandtoggle() {
    this.expand1 = !this.expand1;
    this.currentProject.name = localStorage.getItem("projectName") || "";
  }

  hideList() {
    this.expand1 = false;
  }

  showPageOptionsMenu() {
    // Clear any pending hide timeout
    if (this.hideDropdownTimeout) {
      clearTimeout(this.hideDropdownTimeout);
      this.hideDropdownTimeout = null;
    }
    this.showPageOptionsDropdown = true;
  }

  hidePageOptionsMenu() {
    // Add a small delay to allow smooth transition from trigger to dropdown content
    this.hideDropdownTimeout = setTimeout(() => {
      this.showPageOptionsDropdown = false;
    }, 150);
  }

  cancelHideDropdown() {
    // Cancel the hide timeout when mouse enters dropdown content
    if (this.hideDropdownTimeout) {
      clearTimeout(this.hideDropdownTimeout);
      this.hideDropdownTimeout = null;
    }
  }

  onMenuItemClick() {
    this.showPageOptionsDropdown = false;
    if (this.hideDropdownTimeout) {
      clearTimeout(this.hideDropdownTimeout);
      this.hideDropdownTimeout = null;
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hideList();
      this.hidePageOptionsMenu();
    }
  }

  setCurrentComponent(url: string) {
    // Extract the component name from the URL
    const componentName = url.split('/')[1]; // Assuming the component name is the first segment of the URL

    this.currentComponent = componentName;
  }

  getCurrentComponent() {
    return this.currentComponent;
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  switchToNewUI(): void {
    localStorage.setItem('version', 'v2');
    window.location.reload();
  }
}